export var getOptionsWithSearch = function getOptionsWithSearch(options, searchValue) {
  var regExp = new RegExp("^".concat(searchValue.replace('+', '\\+')), 'i');
  return options.filter(function (_ref) {
    var name = _ref.name,
        value = _ref.value;
    return regExp.test(name) || regExp.test(value);
  });
};